import React from 'react';
import { Route } from 'react-router-dom';
import { initializeGA } from '../utils/ga';
//
export default function PublicRouter(props){
    initializeGA(props.path);
    return(
        <Route path={props.path} component={props.component} {...props} />
    );
}